export class HermesConfig {
  config = {
    configURL: `/h20/api/config`,
    v1ConfigURL: '/api/config/v1.0',
    securityURL: '/api/security'
  };

  private _getConfigURL() {
    return `${this.config.configURL}/v2.0`;
  }

  getSecurityServiceURL() {
    return `${this.config.securityURL}/v2.0`;
  }

  getIntegrationsURL() {
    return `${this._getConfigURL()}/integrations`;
  }

  getStagedIntegrationsURL() {
    return `${this._getConfigURL()}/staged-integrations`;
  }

  getV1IntegrationURL() {
    return `${this.config.v1ConfigURL}/integrations`;
  }

  getSourcesURL() {
    return `${this._getConfigURL()}/sources`;
  }

  getDestinationsURL() {
    return `${this._getConfigURL()}/destinations`;
  }

  getJobsURL() {
    return `${this._getConfigURL()}/jobs`;
  }

  getObjectsURL() {
    return `${this._getConfigURL()}/objects`;
  }

  getFailureHandlingURL() {
    return `${this._getConfigURL()}/failure`;
  }

  getTaskFlowURL() {
    return `${this._getConfigURL()}/task-requests`;
  }

  getAlertServiceURL() {
    return `${this._getConfigURL()}/alerts-service`;
  }

  getActivityLogsURL() {
    return `${this.config.v1ConfigURL}/activity-logs`;
  }

  getActivityLogsV2URL() {
    return `${this._getConfigURL()}/activity-logs`
  }

  getFeedbackURL() {
    return `${this._getConfigURL()}/feedback`;
  }
}

export const hermesConfig = new HermesConfig();
